module.exports = __webpack_public_path__ + "img/table-addrb-icon-white.5d3a9697.svg";